import { PaymentPayPayload } from '~/types/paymentTypes';
import { appApi } from '~/redux/api/appApiSlice';

export const PaymentApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    PostPaymentPay: builder.mutation<any, PaymentPayPayload>({
      query: (body) => ({
        url: 'api/v4/payment/pay',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostPaymentPayMutation } = PaymentApiSlice;
